module.exports = __webpack_public_path__ + "img/A zrtx b  oaxrd   – 2.a8b0edda.png";